import {IosDeviceDependencies as Dependencies} from '../types';

export function isNativeWebView(di: Dependencies = {}): boolean {
  const {wndw = window} = di;
  return wndw.navigator.userAgent === 'iPhone';
}
